const o = new URL("../../assets/icon-community-doodi-kwai-light-DOzIrDOA.png", import.meta.url).href;
export {
  o as default
};
//# sourceMappingURL=icon-community-doodi-kwai-light.png.js.map
